import {BehaviorSubject, of} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import {mc} from '@/core';
import {userApi} from '@/api/user';
import {userStatus$} from './auth';

export interface AccountGray {
  ptMining: boolean;
  sbt: boolean;
  pt: boolean;
  lendingAccount: boolean;
  spotUta: boolean;
  ptSpotFeeDeduct: boolean;
  ptContractFeeDeduct: boolean;
  lending: boolean;
  withdrawPassKeyVerify: boolean;
  maAccount?: boolean;
}

export const initAccountGray$ = new BehaviorSubject<boolean>(true);
export const accountGray$ = new BehaviorSubject<AccountGray>(createAccountGray());

userStatus$
  .pipe(
    filter((status) => status !== 'Init'),
    switchMap((status) => {
      if (status === 'Logout') {
        return of(createAccountGray());
      }
      return loadGray();
    })
  )
  .subscribe((state) => {
    initAccountGray$.next(false);
    accountGray$.next(state);
  });

async function loadGray(): Promise<AccountGray> {
  const {data, error} = await userApi.getUserBizGray();
  if (error) {
    mc.send('toast', 'error', error);
  }
  return data || createAccountGray();
}

function createAccountGray(): AccountGray {
  return {
    ptMining: false,
    sbt: false,
    pt: false,
    lendingAccount: false,
    spotUta: false,
    ptSpotFeeDeduct: false,
    ptContractFeeDeduct: false,
    lending: false,
    withdrawPassKeyVerify: false,
    maAccount: false,
  };
}
